/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Who_TitleInputs */

const da_privacy_who_title = /** @type {(inputs: Privacy_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvem er vi`)
};

/** @type {(inputs: Privacy_Who_TitleInputs) => LocalizedString} */
const en_privacy_who_title = da_privacy_who_title;

/**

* @param {Privacy_Who_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_who_title = /** @type {((inputs?: Privacy_Who_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Who_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_who_title(inputs)
	return /** @type {LocalizedString} */ ("Hvem er vi")
});